/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alert_New_Ostrich_GrinInputs */

const fr_alert_new_ostrich_grin = /** @type {(inputs: Alert_New_Ostrich_GrinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favicon mis à jour`)
};

/**

* @param {Alert_New_Ostrich_GrinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const alert_new_ostrich_grin = /** @type {((inputs?: Alert_New_Ostrich_GrinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alert_New_Ostrich_GrinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_alert_new_ostrich_grin(inputs)
});